const pathUrl = {
    baseUrl:"https://locpro.idrblab.cn/api",
    // baseUrl:"http://127.0.0.1:8008/api",
    localUrl:"https://locpro.idrblab.cn",
}

export default pathUrl;